module.exports = __webpack_public_path__ + "static/media/loyalty-message-background.42119225.png";